const mixin = {
    data() {
        return {
            recordsPage: [5, 10, 20, 30, 100],
            pagination: {
                page: 1,
                pageCount: 0,
                maxResultCount: 5,
            },
        }
    }
}

export default mixin;